import { useMemo } from 'react';

export default function useSimplePromise(returnValue: any): Promise<any> {    
    const promise = useMemo(() => new Promise((resolve,) => resolve(returnValue)), [returnValue]);

    return promise;
}
